import React from 'react'
import { jt, t } from 'ttag'
import PropTypes from 'prop-types'

import { ExpressInterest } from '../ExpressInterest'

const WBLApplicationDetails = ({ profile, section, selectedCluster }) => {
  const cl = <b key="cluster-bold">{t`clusters`}</b>
  const occs = <b key="occs-bold">{t`occupations`}</b>
  const participate = <b key="part-bold">{t`participate`}</b>
  const app = <b key="app-bold">{t`application`}</b>
  const interested = <b key="intst-bold">{t`interested`}</b>
  // console.log(profile, section)
  const textContent = () => {
    let content = {
      topTitle: section.title,
      topContent: section.body,
      bottomContent: section.footer
    }

    if (section.sectionCssClass?.includes('wbl-remote-learning')) {
      content = {
        topTitle: t`What is Remote Learning?`,
        topContent: t`A remote learning local opportunity is one that allows individuals to gain experience and skills
                        remotely, either from home, school or elsewhere. Companies may provide "asynchronous" learning
                        opportunities including online coursework and curriculums.`,
        bottomContent: t`Are you an individual who is unable to commute to a company or organization location or who must for
                        any reason attain skills and experience remotely? Remote Learning opportunities can further an
                        individual's pursuit of skills and experience while allowing them the flexibility to conduct the
                        opportunities requirements either via online work or other forms of remote work.`
      }
    } else if (section.sectionCssClass?.includes('wbl-onsite-training')) {
      content = {
        topTitle: t`What is Onsite Training?`,
        topContent: t`An onsite training local opportunity is one where an individual conducts work or other 
                        activities at an employer’s location.  These opportunities include things like apprenticeships, internships 
                        and job shadowing. These opportunities may require the individual to commute to an employer’s location and a 
                        commitment of individual time to fulfill the requirements involved.`,
        bottomContent: t`Are you ready to gain real world experience "on the job"? Onsite training local opportunities 
                        often involve roles and responsibilities within an external organization.  Internships and apprenticeships, 
                        for examples, may require a certain number of hours of work each week, reviews of individual performance and 
                        an opportunity to showcase your skills, talent and passion. `
      }
    } else if (section.sectionCssClass?.includes('wbl-advisory')) {
      content = {
        topTitle: t`What is an Advisory Opportunity?`,
        topContent: t`An advisory local opportunity is one where a professional within an industry provides the 
                        opportunity to directly advise, guide or help individual students in project work, skills development, 
                        independent projects, or direct mentorship.`,
        bottomContent: t`Are you looking to connect one on one with a local professional or industry leader to help 
                        guide you through mentorship, advisory services, project or skills development? If so this could be a 
                        great category for you.`
      }
    } else if (section.sectionCssClass?.includes('wbl-community-engagement')) {
      content = {
        topTitle: t`What is Community Engagement?`,
        topContent: t`A community engagement local opportunity is one where a company or organization is willing to 
                        host a class field trip or tour, individual site visit, or provide a professional to speak to a class 
                        or participate in a career fair.`,
        bottomContent: t`Are you in a student leadership role, or an educator looking to coordinate a field trip,
                        site visit, classroom speaker or career fair and hoping to recruit a local professional to participate? 
                        If so this could be a great category for you.`
      }
    }

    return (
      <div key={`wbl-app-detail-${section.sectionCssClass}`}>
        <img
          src={'/images/headed2/new/localopportunities/participate/WhatIsThis.svg'}
          aria-hidden="true"
          alt={t`Image about what is this opportunity?`}
          style={{ float: 'right', maxWidth: '40%' }}
        />
        <div>
          <h4 className="profile-emphasized-heading main-title">
            <strong>{content.topTitle}</strong>
          </h4>
          <p dangerouslySetInnerHTML={{ __html: content.topContent }}></p>
        </div>
        <br className="clear" />
        <img
          src={'/images/headed2/new/localopportunities/participate/IsItRightForMe.svg'}
          aria-hidden="true"
          alt={t`Image to represent Is it right for me?`}
          style={{ float: 'left', maxWidth: '40%' }}
        />
        <div style={{ maxWidth: '60%', float: 'left' }}>
          <h4 className="profile-emphasized-heading main-title">
            <strong>{t`Is it Right for Me?`}</strong>
          </h4>
          <p dangerouslySetInnerHTML={{ __html: content.bottomContent }}></p>
        </div>
      </div>
    )
  }

  return (
    <div className="wbl-application-detail-block">
      <div className="col-sm-8 col-xs-12">{textContent()}</div>
      <div className="col-sm-4 col-xs-12">
        <div
          className="how-can-participate"
          style={{ backgroundColor: '#eee', padding: '15px' }}>
          <h4 className="profile-emphasized-heading main-title">{jt`How can I ${participate}?`}</h4>
          <div className="wbl-application-block">
            <ul>
              <li className="first" key="li1">
                {jt`Explore the ${cl} and ${occs} you would like to pursue`}
              </li>
              <li className="second" key="li2">
                {jt`Figure out how you would like to ${participate}`}
              </li>
              <li className="third" key="li3">
                {profile.wblIsApplication
                  ? jt`Submit an ${app}`
                  : jt`Let us know you are ${interested}`}
              </li>
            </ul>
          </div>

          <ExpressInterest profile={profile} selectedCluster={selectedCluster} />
        </div>
      </div>
    </div>
  )
}

WBLApplicationDetails.propTypes = {
  profile: PropTypes.object,
  section: PropTypes.object,
  selectedCluster: PropTypes.string
}

export default WBLApplicationDetails
